import styles from '../Products.module.css';
import { DocumentRequirements } from './DocumentRequirements/DocumentRequirements';
import { FlexiLoanFeatures } from './FlexiLoanFeatures/FlexiLoanFeatures';
import { FlexiLoanProcess } from './FlexiLoanProcess/FlexiLoanProcess';
import { IwocaPayWidget } from './IwocaPayWidget/IwocaPayWidget';

export const ProductsUK = () => {
  return (
    <div id="products-page" className={styles.container}>
      <FlexiLoanFeatures />
      <DocumentRequirements />
      <FlexiLoanProcess />
      <IwocaPayWidget />
    </div>
  );
};
